import { BreadCrumbItem } from "../BreadCrumbs";
import { type Template } from "@zapier/templates";

export const getBreadcrumbs = (template: Template): BreadCrumbItem[] => {
  return [{ text: "Templates", href: "/templates" }, { text: template.name }];
};
